<template>
  <v-app id="portal" class="mt-15">
    <div class="ma-5">
      <v-card outlined elevation="0">
        <v-card-text class="pa-0">
          <v-data-table
            :headers="headers"
            :items="items"
            disable-pagination
            hide-default-footer
          >
            <template v-slot:[`item.preco`]="{ item }">
              {{
                item.preco.toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })
              }}
            </template>
            <template v-slot:[`item.quantidade`]="{ item }">
              <v-text-field
                dense
                solo
                hide-details
                single-line
                type="number"
                v-model.number="item.qtPedida"
                @input="somaValorTotal(item)"
              ></v-text-field>
            </template>
            <template v-slot:[`item.vlrTotal`]="{ item }">
              {{
                item.vlrTotal.toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })
              }}
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </div>
    <div class="d-flex justify-end pr-5">
      <v-card elevation="0" outlined width="220px">
        <v-card-text>
          Total do pedido:
          <strong class="pl-2">{{
            totalPedido.toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            })
          }}</strong>
        </v-card-text>
      </v-card>
    </div>

    <div class="d-flex justify-end pr-5 mt-2">
      <v-btn
        :loading="loading"
        @click="gravaPedido"
        width="220px"
        outlined
        x-large
        >Gravar pedido</v-btn
      >
    </div>

    <v-snackbar
      v-model="snackbar"
      bottom
      right
      :timeout="8000"
      :vertical="false"
      color="green"
    >
      Pedido gravado com sucesso!
      <v-btn color="white" text @click="snackbar = false">OK</v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import Service from "../components/api/Service";
import { snackbar } from "cids-cgi/lib/util";
import Handler from "@/core/services/Handler";

export default {
  data: () => ({
    snackbar: false,
    loading: false,
    headers: [
      {
        text: "Produto",
        value: "produto",
        divider: true,
        sortable: false,
      },
      {
        text: "Descrição",
        value: "descricao",
        divider: true,
        sortable: false,
      },
      {
        text: "Embalagem",
        value: "embalagem",
        divider: true,
        sortable: false,
      },
      {
        text: "Validade",
        value: "validade",
        divider: true,
        sortable: false,
      },
      {
        text: "Preço",
        value: "preco",
        align: "end",
        divider: true,
        sortable: false,
      },
      {
        text: "Quantidade",
        value: "quantidade",
        width: "100px",
        divider: true,
        sortable: false,
      },
      {
        text: "Valor total",
        value: "vlrTotal",
        align: "end",
        divider: true,
        sortable: false,
      },
    ],
    items: [],
  }),
  async mounted() {
    const service = new Service();
    const responsePedido = await service.getStatusVarejo();
    const response = await service.buscaItensDoVarejo();

    this.items =
      response?.data?.ttItemVarejo.map((item) => {
        delete item.dtHrAtualizacao;
        return {
          qtPedida: item.qtdPedido,
          vlrTotal: item.preco * item.qtdPedido,
          codPessoa: responsePedido.data.ttPedido[0].codPessoa,
          codEmp: responsePedido.data.ttPedido[0].codEmp,
          dtCompetencia: responsePedido.data.ttPedido[0].dtCompetencia,
          codEmpregado: responsePedido.data.ttPedido[0].codEmpregado,
          ...item,
        };
      }) ?? [];
  },
  computed: {
    totalPedido: function () {
      return this.items.reduce(function (acc, obj) {
        return acc + obj.vlrTotal;
      }, 0);
    },
  },
  methods: {
    somaValorTotal(item) {
      item.vlrTotal = item.qtPedida * item.preco;
    },
    async gravaPedido() {
      try {
        this.loading = true;
        const service = new Service();

        const response = await service.gravaItensDoVarejo(this.items);

        if (response.data.retorno[0].estatus !== "Sucesso") {
          throw response;
        }

        this.snackbar = true;
      } catch (error) {
        const errorMessage = new Handler().handlesError(error);

        snackbar.show({ message: errorMessage, timeout: 5000 });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
